import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import clsx from 'clsx'
import FadeIn from '../../molecules/Transitions/FadeIn'
import Skeleton from '../../atoms/Skeleton'
import ResponsiveSimpleGauge from '../../nivo/SimpleGauge/ResponsiveSimpleGauge'
import { useSimpleGaugeData } from './useRangedGaugeData'

const useStyles = makeStyles((theme) => ({
  keyDatapointGauge: {
    height: '100%',
    '&.__empty': {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '22px'
    },

    '& svg text': {
      color: ({ textColor }) => textColor,
      fill: ({ textColor }) => textColor
    }
  }
}))

function SimpleKeyDatapointGauge ({
  style,
  className,
  keyDatapoint,
  noDataMessage,
  textColor,
  ...otherProps
}) {
  const classes = useStyles({ textColor })
  const { marker, isLoading } = useSimpleGaugeData(keyDatapoint, otherProps)

  if (isLoading) {
    return (
      <FadeIn duration={5} delay={5} style={style} className={clsx(className, classes.keyDatapointGauge)}>
        <Skeleton width='100%' height='100%' />
      </FadeIn>
    )
  }

  if (!marker) {
    return (
      <FadeIn style={style} className={clsx(className, classes.keyDatapointGauge, '__empty')}>
        <div>{noDataMessage}</div>
      </FadeIn>
    )
  }

  return (
    <FadeIn duration={1} style={style} className={clsx(className, classes.keyDatapointGauge)}>
      <ResponsiveSimpleGauge
        marker={marker}
        {...otherProps}
      />
    </FadeIn>
  )
}

SimpleKeyDatapointGauge.propTypes = {
  style: PropTypes.any,
  className: PropTypes.string,
  keyDatapoint: PropTypes.string,
  markerColor: PropTypes.string,
  textColor: PropTypes.string,
  noDataMessage: PropTypes.string,
  valueFormat: PropTypes.string
}

SimpleKeyDatapointGauge.defaultProps = {
  markerColor: 'red',
  noDataMessage: 'No Data Available',
  valueFormat: 'percentage',
  variant: 'ranged'
}

export default SimpleKeyDatapointGauge
